// extracted by mini-css-extract-plugin
var _1 = "UmKeaEuVSZ";
var _2 = "UtO6z7iTkc";
var _3 = "HacF2SAOPE";
export { _1 as "large", _2 as "root", _3 as "small" }
